import { render } from "./distributorTable.vue?vue&type=template&id=4de623aa&scoped=true&ts=true"
import script from "./distributorTable.vue?vue&type=script&lang=ts"
export * from "./distributorTable.vue?vue&type=script&lang=ts"

import "./distributorTable.vue?vue&type=style&index=0&id=4de623aa&scoped=true&lang=less"

import exportComponent from "/opt/jenkins/workspace/WF-cloud-admin-beta/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4de623aa"]])

export default __exports__